import {tagColors} from "@/components/tag/tag-colors";

export const HeadLogistics = {
  base: {
    status: {
      ENABLE: 'enable',
      DISABLE: 'disable',
    },
    statusOption: [
      {id: 'enable', text: '启用',...tagColors.greenText},
      {id: 'disable', text: '停用',...tagColors.gray9Text},
    ],
    chargeTypeOption: [
      {id: 'weight', text: '实重(KG)'},
      {id: 'volume', text: '体积(CBM)'},
      {id: 'charge', text: '体积重(KG)'},
    ]
  }
};
